import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SilentPicker from '../SilentPicker/SilentPicker';

import { useCommentSlice } from '../CommentState';
import {
  selectSelectedFilter,
  selectFilterOptions,
  selectIsLoadingFilterOptions
} from '../CommentState/selectors';

function FilterPanel() {
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();

  // Get state from Redux
  const selectedFilter = useSelector(selectSelectedFilter);
  const filterOptions = useSelector(selectFilterOptions);
  const isLoadingOptions = useSelector(selectIsLoadingFilterOptions);

  const selectedDropDownHandler = (
    key: string,
    item: any,
    filterLabel?: string
  ) => {
    dispatch(actions.setCurrentCommentId(null));
    dispatch(actions.filterChanged({ key, item, filterLabel }));
  };

  return (
    <div style={{ position: 'relative' }}>
      <label htmlFor="filter-dropdown">Filters : </label>
      {isLoadingOptions ? (
        <span>Loading filters...</span>
      ) : (
        <SilentPicker
          id="filter-dropdown"
          items={filterOptions}
          selectedKey={selectedFilter ? selectedFilter.key : ''}
          onSelectionChange={selectedDropDownHandler}
        />
      )}
    </div>
  );
}

export default FilterPanel;
